var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"associated-documents"},[_c('transition-group',{staticClass:"item-list",attrs:{"tag":"div","name":"fade"}},_vm._l((_vm.documents),function(document,index){return _c('sheet-block-associated-documents-select-item',{key:document.type,attrs:{"document":document}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }